import React from "react";
import Helmet from "react-helmet";
import { graphql } from "gatsby";
import Layout from "../components/layout";

const heading = "text-5xl text-center leading-tight text-blue-darkest";

export default function Template({
  data // this prop is injected by GraphQL query
}) {
  const { markdownRemark: post } = data;
  const {
    site: {
      siteMetadata: { title: blogTitle }
    }
  } = data;
  console.log("?" + post.frontmatter.site);
  return (
    <Layout path={post.frontmatter.site}>
      <div className="blog-post-container p-2">
        <Helmet title={`${blogTitle} | ${post.frontmatter.title}`} />
        <div className="blog-post">
          <h1 className={heading}>{post.frontmatter.title}</h1>
          <div
            className="blog-post-content px-4 text-grey-darkest"
            dangerouslySetInnerHTML={{ __html: post.html }}
          />
        </div>
      </div>
    </Layout>
  );
}

export const pageQuery = graphql`
  query BlogPostByPath($path: String!) {
    site {
      siteMetadata {
        title
      }
    }
    markdownRemark(frontmatter: { path: { eq: $path } }) {
      html
      frontmatter {
        date(formatString: "MMMM DD, YYYY")
        path
        title
        site
      }
    }
  }
`;
